module.exports = __webpack_public_path__ + "static/img/logo.b2054a32.png";